<ng-container *ngIf="enabled && !hiddenOnChatPage">
  <button
    type="button"
    class="ai-fab"
    [class.ai-fab--hidden]="hiddenByRightBar"
    [class.ai-fab--open]="isOpen$ | async"
    [attr.aria-label]="(isOpen$ | async) ? 'Close Remmi AI' : 'Open Remmi AI'"
    (click)="toggle()">
    <i class="pi" [ngClass]="(isOpen$ | async) ? 'pi-times' : 'pi-microchip-ai'"></i>
  </button>

  <app-ai-assistant-panel></app-ai-assistant-panel>
</ng-container>
